import { call, put, takeEvery } from "redux-saga/effects";
import SweetAlert from "../../../components/sweetalert/SweetAlert";
import * as types from "./TenantHierarchyConfigurationActionType";
import * as actions from "./TenantHierarchyConfigurationActions";
import * as services from "./TenantHierarchyConfigurationServices";

function* getMasterHierarchySaga() {
  try {
    const response = yield call(services.getMasterHierarchyService);
    yield put(actions.getMasterHierarchySuccess(response?.values || []));
  } catch (error) {
    const errorMessage = error?.message || "Failed to fetch hierarchy master.";
    yield put(actions.getMasterHierarchyFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* getTenantHierarchyConfigurationSaga(action) {
  try {
    const response = yield call(services.getTenantHierarchyConfigurationService, action.payload);
    yield put(actions.getTenantHierarchyConfigurationSuccess(response?.values || {}));
  } catch (error) {
    const errorMessage = error?.message || "Failed to fetch tenant hierarchy configuration.";
    yield put(actions.getTenantHierarchyConfigurationFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* saveTenantHierarchyConfigurationSaga(action) {
  try {
    const response = yield call(services.saveTenantHierarchyConfigurationService, action.payload);

    if (response?.success) {
      yield put(actions.saveTenantHierarchyConfigurationSuccess(response));
      yield put(actions.getTenantHierarchyConfigurationRequest(action.payload?.TenantId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Tenant hierarchy configuration saved successfully.",
      });
    } else {
      const errorMessage = response?.errorMessage || "Failed to save tenant hierarchy configuration.";
      yield put(actions.saveTenantHierarchyConfigurationFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.errorMessage || error?.message || "Failed to save tenant hierarchy configuration.";
    yield put(actions.saveTenantHierarchyConfigurationFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* bulkUpdateTenantHierarchyAliasSaga(action) {
  try {
    const response = yield call(services.bulkUpdateTenantHierarchyAliasService, action.payload);

    if (response?.success) {
      yield put(actions.bulkUpdateTenantHierarchyAliasSuccess(response));
      yield put(actions.getTenantHierarchyConfigurationRequest(action.payload?.TenantId));
      SweetAlert.success({
        title: "Success!",
        text: response?.resultMessage || "Tenant hierarchy aliases updated successfully.",
      });
    } else {
      const errorMessage = response?.errorMessage || "Failed to update tenant hierarchy aliases.";
      yield put(actions.bulkUpdateTenantHierarchyAliasFailure(errorMessage));
      SweetAlert.error({ title: "Error!", text: errorMessage });
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.errorMessage || error?.message || "Failed to update tenant hierarchy aliases.";
    yield put(actions.bulkUpdateTenantHierarchyAliasFailure(errorMessage));
    SweetAlert.error({ title: "Error!", text: errorMessage });
  }
}

function* TenantHierarchyConfigurationSaga() {
  yield takeEvery(types.GET_MASTER_HIERARCHY_REQUEST, getMasterHierarchySaga);
  yield takeEvery(types.GET_TENANT_HIERARCHY_CONFIGURATION_REQUEST, getTenantHierarchyConfigurationSaga);
  yield takeEvery(types.SAVE_TENANT_HIERARCHY_CONFIGURATION_REQUEST, saveTenantHierarchyConfigurationSaga);
  yield takeEvery(types.BULK_UPDATE_TENANT_HIERARCHY_ALIAS_REQUEST, bulkUpdateTenantHierarchyAliasSaga);
}

export default TenantHierarchyConfigurationSaga;
